<script lang="ts" setup>
import { CATALOG_PAGE_TYPES } from '~/constants/catalogPageTypes';

const { selectedOffer, selectedSizeId, currentPageType } = storeToRefs(useCatalogStore());

const isShowLoyaltyModal = ref(false);

const loyalty = computed(() => {
  if (currentPageType.value === CATALOG_PAGE_TYPES.OFFER_GROUP_PAGE) {
    if (!selectedSizeId.value) return null;

    return selectedOffer.value.offers.find((offer) => offer.id === selectedSizeId.value)?.loyalty ?? null;
  } else {
    return selectedOffer.value.loyalty ?? null;
  }
});
</script>

<template>
  <button
    v-if="loyalty"
    class="product-page-loyalty-block"
    @click="isShowLoyaltyModal = true"
  >
    <div class="flex items-center gap-2">
      <span class="font-bold">{{ loyalty.toLocaleString('ru-RU') }}</span>

      <RoundBlackH />

      <span class="text-sm">будет начислено за покупку</span>
    </div>

    <div class="product-page-loyalty-block__show-more">
      <div class="hidden sm:block md:hidden lg:block">Подробнее</div>

      <SvgoChevronRight
        :font-controlled="false"
        class="size-3"
        filled
      />
    </div>

    <LoyaltyModal
      v-model="isShowLoyaltyModal"
      @close="isShowLoyaltyModal = false"
    />
  </button>
</template>

<style lang="scss" scoped>
.product-page-loyalty-block {
  display: flex;
  gap: 4px;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border: 1px solid $hell-black-10;
  border-radius: 8px;
  background-color: $white;

  &__show-more {
    display: flex;
    gap: 4px;
    align-items: center;
    color: $hell-black-40;
    font-size: $text-xs;
    transition: color 0.2s;
  }

  &:hover {
    .product-page-loyalty-block__show-more {
      color: $label-violet;
    }
  }
}
</style>
